var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"similar-articles"},[_c('p',{staticClass:"box-title"},[_vm._v("Похожие статьи")]),_c('posts-list',{attrs:{"posts":_vm.posts}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }